import { render, staticRenderFns } from "./commentsReports.vue?vue&type=template&id=caf6919e&"
import script from "./commentsReports.vue?vue&type=script&lang=js&"
export * from "./commentsReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports